module.exports = __webpack_public_path__ + "assets/money-dark.d0778bc1.svg";